<template>
  <div>
    <ui-modal
      ref="modal"
      @close="ActionSetVisibleModalEditar(false)"
      :title="`Actualizar Módulo - ${titulo}`"
    >
      <div class="d-flex">
        <ui-textbox
          class="w-100 mr-3"
          floating-label
          label="Nombre"
          v-model="formulario.nombreModel"
        />
        <ui-textbox
          class="w-100"
          floating-label
          label="Ícono"
          v-model="formulario.iconoModel"
        />
      </div>
      <div class="d-flex">
        <div class="w-100 mr-3"></div>
        <div class="d-flex w-100">
          <div class="w-75"><h6>Ícono seleccionado:</h6></div>
          <div class="w-25" v-if="formulario.iconoModel.length > 0">
            <i :class="formulario.iconoModel" style="font-size: 18pt"></i>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <div class="d-flex justify-content-between mt-3">
        <button class="btn btn-outline-secondary" @click="closeModal('modal')">
          Cerrar
        </button>
        <button class="btn btn-outline-primary" @click="actualizarModulo">
          Guardar
        </button>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Vue
import Vue from "vue";

// Vuex
import { mapState, mapActions } from "vuex";

// Toast
import VueToastify from "vue-toastify";
Vue.use(VueToastify);

// UI Modal
import UiModal from "keen-ui/src/UiModal";
import UiTextbox from "keen-ui/src/UiTextbox";

// Constantes
import {
  updateModulos,
  getModulos,
} from "../../../../constants/superadministrador";

export default {
  props: {
    data: [Array, Object],
  },
  data() {
    return {
      formulario: {
        id: "",
        nombreModel: "",
        iconoModel: "",
      },
      titulo: "",
      dataAux: this.data,
    };
  },

  components: {
    UiModal,
    UiTextbox,
  },

  computed: {
    ...mapState(["visibleModalEditar"]),
  },

  methods: {
    ...mapActions("superadministrador", ["actionSetDataModulos"]),
    ...mapActions(["ActionSetVisibleModalEditar"]),

    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },

    async actualizarModulo() {
      let sql = await updateModulos(this.formulario);

      if (!sql.error) {
        // Toast proceso exitoso
        this.$vToastify.success("Módulo actualizado con éxito", "¡Realizado!");

        // Limpiar variables
        this.formulario.nombreModel = "";
        this.formulario.iconoModel = "";

        let dataModulosDB = await getModulos();
        this.dataAux = dataModulosDB;

        this.actionSetDataModulos(dataModulosDB.data_table);

        // Cerrar Modal
        this.closeModal("modal");
      } else {
        if (sql.data.length > 0) {
          // Errores de validación
          sql.data.map((item) => {
            this.$vToastify.error(`${item}`);
          });
        } else {
          // Proceso erroneo
          this.$vToastify.error(
            "El Módulo no ha podido actualizarse",
            "¡Error!"
          );
        }
      }
    },
  },
  watch: {
    visibleModalEditar: function (_new) {
      _new && this.openModal("modal");
    },
    data: function (_new) {
      this.titulo = _new.data[0];

      // Formulario
      this.formulario.id = _new.data_complementaria.id_modulo;
      this.formulario.nombreModel = _new.data[0];
      this.formulario.iconoModel = _new.data[1];
    },
  },
};
</script>
